/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox, Field } from '@cleartrip/bento'

import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'
import OfflineToast from '../offlineToast'
import { SVGComponent } from '../..'
import {
  getUserByMobile,
  saveNudge,
  sendOtpForSignIn
} from '../../../pages/Trips/trips.helper'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'
import ModalHeader from '../UserProfileModalHeader'
import { errorConfig } from './errorConfig'

import OtpBox from './otpBox'

const VerifyMobileInputField = ({
  toggle,
  mobileAndCountryCodeItem,
  setPageName,
  validateMobileHandler,
  isMobileValid,
  handleLinkClick,

  email,
  mobile,
  countryCode,
  abLogin = 'a'
}) => {
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }

  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
  const [countDown, setCountDown] = useState(0)
  const [retriesLeft, setRetriesLeft] = useState(4)
  const [animationParams, setAnimationParams] = useState(animationDefaultState)
  const [apiError, setApiError] = useState('')
  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-8': 'px-8'
  })
  const errorInfo = 'fs-inherit c-inherit pl-2'
  useEffect(() => {
    refs[0] && refs[0].current && refs[0].current.focus()
  }, [])

  const getOtp = async () => {
    setApiError('')
    const mobileValid = validateMobileHandler()
    if (mobileValid) {
      const payload = {
        type: 'MOBILE',
        value: mobile,
        countryCode,
        action: 'UPDATE_MOBILE'
      }
      const response = await sendOtpForSignIn(payload)
      const { status, data, error } = response || {}
      if (status === 202) {
        const { action } = data || {}
        setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER)
      } else {
        const { response = { data: {} } } = error || {}
        const { data = {} } = response
        const { message } = data
        const err = errorConfig[message] || errorConfig.default
        setApiError(err)
      }
    } else {
      ClevertapEvent({
        actionName: 'Invalid_value_entered',
        actionType: 'Button',
        login_banner_cookie: abLogin,
        page:
          pagePath === 'results'
            ? 'SRP'
            : isEmpty(pagePath)
            ? 'HP'
            : pathname.length > 4 &&
              pathname[4] === 'info' &&
              pathname[2] === 'itinerary'
            ? 'Itinerary'
            : 'Confirmation_Page',

        field_name: 'mobile',
        form_name: 'VerifyMobile'
      })
    }
  }
  return (
    <div
      className="bg-white br-4 br-4 o-hidden d-flex flex-column"
      style={{
        width: '400px',
        height: '468px'
      }}
    >
      <div className={`${animatedClass} d-flex flex-1 flex-column`}>
        <ModalHeader title="Verify mobile number" toggle={toggle} />

        <div className="d-flex flex-column flex-between flex-1">
          <div>
            <OfflineToast page="verify mobile number" />
            {apiError && (
              <>
                <div className="py-2 px-2 h-8 flex flex-middle bg-error-600 c-white fs-2 br-4 ">
                  <SVGComponent
                    svgIcon="info_icon"
                    className="c-white"
                    height={16}
                    width={16}
                  />
                  <span data-testid="signinError" className={errorInfo}>
                    {apiError}
                  </span>
                </div>
                <Spacer className="pt-4" />
              </>
            )}
            <span className="fs-3 c-neutral-700">{'For account '} </span>{' '}
            <span className="fs-3 c-neutral-700 fw-600">{email}</span>
            <Spacer className="mt-3" />
            {mobileAndCountryCodeItem}
            <div className="mt-6">
              <div className="bg-neutral-0 px-4 py-4">
                <div className="fs-3 fw-600 c-grey-90">
                  Benefits of verifying mobile number
                </div>
                <div style={{ marginTop: '14px' }}>
                  <div className="d-flex">
                    <SVGComponent
                      svgIcon="successSmall"
                      height={12}
                      width={12}
                    />
                    <div
                      className="fs-2 fw-500 c-grey-90 ml-2"
                      style={{ marginBottom: '10px' }}
                    >
                      Secure log in with mobile number and OTP
                    </div>
                  </div>
                  <div className="d-flex">
                    <SVGComponent
                      svgIcon="successSmall"
                      height={12}
                      width={12}
                    />
                    <div className="fs-2 fw-500 c-grey-90 ml-2">
                      Quick, hassle-free login
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-8">
            <div className="mb-4">
              <Button
                size="md"
                type="secondary"
                full={true}
                // onClick={() => goBackAnimation(USER_PROFILE_PAGE_CONTANTS.SIGNIN_PAGE)}
                onClick={async () => {
                  const mobileValid = validateMobileHandler()

                  if (mobileValid) {
                    const response = await getUserByMobile(mobile, countryCode)
                    const { status } = response
                    if (status === 200) {
                      setApiError(
                        'Phone number already associated with another account.'
                      )
                    } else {
                      getOtp()
                    }
                  }
                }}
              >
                <span className="fs-3 fw-550">Get OTP</span>
              </Button>
            </div>
            <div
              className="ta-center fs-3 fw-600 c-blue c-pointer"
              onClick={() => {
                saveNudge('UPDATE_MOBILE')
                toggle()
              }}
            >
              Not Now
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VerifyMobileInputField
